import { LockClosedIcon } from '@heroicons/react/20/solid'

import { classNames } from '../../helper'
import {
  DECISION_STATE_LABELS,
  KIND_LABELS,
  LOCK_NOTICE,
  STATUS_LABELS
} from '../../helper/experiments'
import { DECISION_HINTS, STATUS_HINTS } from './Help'

const BADGE =
  'inline-flex items-center rounded-md px-2 py-1 text-xs font-medium ring-1 ring-inset'

const STATUS_STYLES = {
  draft: 'bg-gray-50 text-gray-600 ring-gray-500/10',
  running: 'bg-green-50 text-green-700 ring-green-600/20',
  paused: 'bg-yellow-50 text-yellow-800 ring-yellow-600/20',
  concluded: 'bg-blue-50 text-blue-700 ring-blue-700/10'
}

const DECISION_STYLES = {
  collecting: 'bg-gray-50 text-gray-600 ring-gray-500/10',
  winner: 'bg-green-50 text-green-700 ring-green-600/20',
  no_effect: 'bg-yellow-50 text-yellow-800 ring-yellow-600/20',
  manual: 'bg-purple-50 text-purple-700 ring-purple-700/10',
  srm: 'bg-red-50 text-red-700 ring-red-600/20'
}

const KIND_STYLES = {
  experiment: 'bg-indigo-50 text-indigo-700 ring-indigo-700/10',
  rollout: 'bg-cyan-50 text-cyan-700 ring-cyan-700/10'
}

const FALLBACK = 'bg-gray-50 text-gray-600 ring-gray-500/10'

export const StatusBadge = ({ status }) => (
  <span
    className={classNames(BADGE, STATUS_STYLES[status] || FALLBACK)}
    title={STATUS_HINTS[status || 'draft']}
  >
    {STATUS_LABELS[status] || status || STATUS_LABELS.draft}
  </span>
)

export const KindBadge = ({ kind }) => (
  <span className={classNames(BADGE, KIND_STYLES[kind] || FALLBACK)}>
    {KIND_LABELS[kind] || kind || '-'}
  </span>
)

export const DecisionBadge = ({ state }) => (
  <span
    className={classNames(BADGE, DECISION_STYLES[state] || FALLBACK)}
    title={DECISION_HINTS[state]}
  >
    {DECISION_STATE_LABELS[state] || state || '-'}
  </span>
)

export const LockNotice = ({ className }) => (
  <div
    className={classNames(
      'flex items-start gap-2 rounded-md bg-amber-50 px-3 py-2 text-xs text-amber-800 ring-1 ring-inset ring-amber-600/20',
      className
    )}
  >
    <LockClosedIcon
      className='mt-0.5 h-4 w-4 flex-shrink-0'
      aria-hidden='true'
    />
    <span>{LOCK_NOTICE}</span>
  </div>
)

export const Notice = ({ tone = 'info', children, className }) => (
  <div
    className={classNames(
      'rounded-md px-3 py-2 text-sm ring-1 ring-inset',
      tone === 'error' && 'bg-red-50 text-red-700 ring-red-600/20',
      tone === 'warning' && 'bg-amber-50 text-amber-800 ring-amber-600/20',
      tone === 'info' && 'bg-blue-50 text-blue-700 ring-blue-700/10',
      className
    )}
  >
    {children}
  </div>
)
